// extracted by mini-css-extract-plugin
module.exports = {"detailsText":"DetailsText_detailsText__hnzUh","label":"DetailsText_label__3l1cM","text":"DetailsText_text__3PTkW","hint":"DetailsText_hint__1tQAk"};